import type { BarcodeScannerFormat, BarcodeScannerFormatKind } from '../types'

export const toFormatKind = (format: BarcodeScannerFormat): BarcodeScannerFormatKind => {
  switch (format) {
    case 'qr_code':
      return 'QR'
    case 'code_39':
    case 'code_128':
    case 'itf':
    default:
      return '1D'
  }
}
